import React from 'react';
import styles from './CTAButton.module.css';

interface CTAButtonProps {
  href: string;
  children: React.ReactNode;
}

export function CTAButton({ href, children }: CTAButtonProps) {
  return (
    <a className={styles.cta} href={href} target="_blank" rel="noopener noreferrer">
      <span className={styles.shine} aria-hidden="true" />
      <svg className={styles.icon} viewBox="0 0 24 24" aria-hidden="true">
        <path
          fill="currentColor"
          d="M21.94 4.46 2.9 11.86c-1.2.48-1.18 1.18-.21 1.48l4.88 1.52 1.86 5.76c.24.66.12.92.81.92.53 0 .77-.24 1.06-.53l2.32-2.26 4.84 3.58c.89.49 1.53.24 1.75-.83l3.18-14.97c.33-1.3-.5-1.89-1.45-1.57z"
        />
      </svg>
      <span className={styles.label}>{children}</span>
    </a>
  );
}
